export enum LIST_PLUGIN_MODE {
    TABLE,
    LIST,
}


// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/plugins/abstract-plugins/list/list-plugin-mode.ts